import { delData, getData, postData, putData } from '../../../utils/fetch-api-util';
import { BenefitType, FormBenefitType, SortBenefitsPayload } from '../../../types/benefit';
import { API_URLS } from '../../../constants/urls/api-urls';

export interface BenefitRequestParams {
  take?: number;
  page?: number;
  country?: string;
}

export interface BenefitTypeResponse {
  benefits: BenefitType[];
  total: number;
}

interface SuccessResponse {
  success: boolean;
}

export const getBenefitListRepository = async (
  url: string,
  data?: BenefitRequestParams,
): Promise<BenefitTypeResponse> => {
  const response = await getData<BenefitRequestParams, BenefitTypeResponse>(url, data);
  return response.data;
};

export const postCreateBenefitRepository = async (payload: FormBenefitType): Promise<void> => {
  await postData<FormBenefitType, SuccessResponse>(API_URLS.BENEFIT_API, payload);
};

export const putUpdateBenefitRepository = async (payload: FormBenefitType): Promise<void> => {
  await putData<FormBenefitType, SuccessResponse>(API_URLS.BENEFIT_URL_WITH_ID(payload?.id || ''), payload);
};

export const deleteBenefitRepository = async (id: string): Promise<void> => {
  await delData<SuccessResponse>(API_URLS.BENEFIT_URL_WITH_ID(id));
};

export const postSortBenefitsRepository = async (payload: SortBenefitsPayload): Promise<void> => {
  await postData<SortBenefitsPayload, SuccessResponse>(API_URLS.BENEFIT_SORT, payload);
};
